<div class="layui-collapse" lay-accordion="">
{{each OnlyOneData item i}}   
    <div class="layui-colla-item">
        <h2 class="layui-colla-title com-doc-t "><span>{{item.Title}}</span><span>{{item.LastUpdateTime.substring(0,10)}}</span></h2>
        <div class="layui-colla-content {{item.show?'layui-show':''}} ">
        <p>{{@item.Content}}</p>
        </div>
    </div>
{{/each}}
</div>